import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["treatmentSelect", "dateInput", "startsAt", "therapistSelect", "tbaHint", "sourceSelect", "foName", "foHint", "slotError", "inRoom"]
  static values = { bookingId: Number }

  connect() {
    this.syncTbaMode()
    this.syncFoNameRequirement()
  }

  treatmentChanged() {
    this.loadSlots()
  }

  serviceLocationChanged() {
    this.startsAtTarget.value = ""
    this.clearSlotSelection()
    this.loadSlots()
  }

  dateChanged() {
    this.loadSlots()
  }

  // Changing the therapist filters availability — clear any chosen slot first.
  therapistChanged() {
    this.startsAtTarget.value = ""
    this.clearSlotSelection()
    this.syncTbaMode()
    this.loadSlots()
  }

  // "TBA" (To Be Assigned) unlocks the far-future booking window and shows a
  // hint, since an unassigned slot isn't bound to any therapist's roster.
  syncTbaMode() {
    if (!this.hasTherapistSelectTarget) return
    const tba = this.therapistSelectTarget.value === "tba"

    const max = tba ? this.dateInputTarget.dataset.maxUnassigned : this.dateInputTarget.dataset.maxDefault
    if (max) this.dateInputTarget.max = max

    if (this.hasTbaHintTarget) this.tbaHintTarget.classList.toggle("hidden", !tba)
  }

  sourceChanged() {
    this.syncFoNameRequirement()
  }

  syncFoNameRequirement() {
    if (!this.hasSourceSelectTarget || !this.hasFoNameTarget) return

    const hotelSource = this.sourceSelectTarget.value === "hotel"
    this.foNameTarget.required = hotelSource
    this.foNameTarget.setAttribute("aria-required", hotelSource ? "true" : "false")

    if (this.hasFoHintTarget) {
      this.foHintTarget.textContent = hotelSource ? "Wajib untuk sumber Hotel." : "Opsional kecuali sumber Hotel."
      this.foHintTarget.classList.toggle("text-error", hotelSource)
      this.foHintTarget.classList.toggle("font-medium", hotelSource)
      this.foHintTarget.classList.toggle("text-olive", !hotelSource)
    }
  }

  loadSlots() {
    const treatmentId = this.treatmentSelectTarget.value
    const date = this.dateInputTarget.value
    if (!treatmentId || !date) return

    const frame = document.getElementById("hotel-slots")
    if (frame) {
      let url = `/dashboard/hotel_bookings/slots?treatment_id=${treatmentId}&date=${date}`
      if (this.hasBookingIdValue) {
        url += `&booking_id=${this.bookingIdValue}`
      }
      if (this.hasTherapistSelectTarget && this.therapistSelectTarget.value) {
        url += `&therapist_id=${this.therapistSelectTarget.value}`
      }
      if (this.hasInRoomTarget && this.inRoomTarget.checked) {
        url += "&in_room=1"
      }
      frame.src = url
    }

    this.startsAtTarget.value = ""
    this.clearSlotSelection()
  }

  // Block submission until a time slot is chosen — prevents a 500 from a
  // blank starts_at reaching the server.
  validateSlot(event) {
    if (this.startsAtTarget.value) {
      if (this.hasSlotErrorTarget) this.slotErrorTarget.classList.add("hidden")
      return
    }

    event.preventDefault()
    if (this.hasSlotErrorTarget) {
      this.slotErrorTarget.classList.remove("hidden")
      this.slotErrorTarget.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }

  selectSlot(event) {
    this.startsAtTarget.value = event.currentTarget.dataset.startsAt
    this.clearSlotSelection()
    event.currentTarget.classList.add("bg-indigo-100", "border-indigo-500", "text-indigo-800")
    event.currentTarget.classList.remove("border-gray-300", "text-gray-700")
    if (this.hasSlotErrorTarget) this.slotErrorTarget.classList.add("hidden")
  }

  clearSlotSelection() {
    document.querySelectorAll(".hotel-slot-btn").forEach(btn => {
      btn.classList.remove("bg-indigo-100", "border-indigo-500", "text-indigo-800")
      btn.classList.add("border-gray-300", "text-gray-700")
    })
  }
}
